import React, { createContext, useEffect, useState } from 'react';
import { ComponentChildren } from 'preact';

export interface Messages {
  [key: string]: string | null;
}

export interface MessagesProviderProps {
  locale: string;
  messages: Messages;
  children?: ComponentChildren;
}

export interface IntlProviderContextValue {
  locale: string;
  messages: Messages;
}

export const IntlProviderContext = createContext<IntlProviderContextValue>({
  locale: '',
  messages: {},
});

const IntlProvider = ({
  locale,
  messages,
  children,
}: MessagesProviderProps): React.JSX.Element | null => {
  const [context, setContext] = useState<IntlProviderContextValue | null>(null);

  useEffect(() => {
    setContext({
      locale,
      messages,
    });
  }, [locale, messages]);

  if (!context) {
    return null;
  }

  return <IntlProviderContext.Provider value={context}>{children}</IntlProviderContext.Provider>;
};

export default IntlProvider;
